module.exports = __webpack_public_path__ + "img/Linda Adams, 1968 (1).83d482cb.jpg";